import React, { memo, useCallback } from 'react';
import { Box, Stack, Button } from '@mui/material';

import { SingleCamIcon, MultiCamIcon } from './Icons';

import styles from './MultiCamControls.module.scss';

interface Props {
  setMultiCamViewActive: (multicamActive: boolean) => void;
  multiCamViewActive: boolean;
  setActiveMenu: React.Dispatch<React.SetStateAction<'NEARBY' | 'ANGLES'>>;
}

const MultiCamControls: React.FC<Props> = ({
  setMultiCamViewActive,
  multiCamViewActive,
  setActiveMenu,
}) => {
  const enableMultiCamView = useCallback(() => {
    setMultiCamViewActive(true);
  }, [setMultiCamViewActive]);

  const enableSingleCamView = useCallback(() => {
    setMultiCamViewActive(false);
    // default to cam angles menu when single cam is enabled
    setActiveMenu('ANGLES');
  }, [setMultiCamViewActive, setActiveMenu]);

  return (
    <Box className={styles.multiCamControlsWrapper}>
      <Stack
        data-testid="multi-cam-controls"
        direction="row"
        justifyContent="center"
        alignItems="center"
        className={styles.multiCamControls}
      >
        <Button
          variant="secondary"
          color="dark"
          onClick={enableMultiCamView}
          disabled={multiCamViewActive}
          className={styles.camControlButton}
          data-testid="multi-cam-button"
          aria-label="Enable multi-cam view"
        >
          <MultiCamIcon active={multiCamViewActive} />
        </Button>
        <Button
          variant="secondary"
          color="dark"
          onClick={enableSingleCamView}
          disabled={!multiCamViewActive}
          className={styles.camControlButton}
          data-testid="single-cam-button"
          aria-label="Enable single-cam view"
        >
          <SingleCamIcon active={!multiCamViewActive} />
        </Button>
      </Stack>
    </Box>
  );
};

export default memo(MultiCamControls);
